import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { handleRequest } from "../../helpers/handleAsync";
import { IProduct } from "../../types/product";
import productService from "../../services/productService";
import productNewService from "../../services/productNewService";

export interface IProductState {
    productStore: IProduct[],
    productDetail: IProduct,
}
const initialState: IProductState = {
    productStore: [],
    productDetail: {} as IProduct,
}

const getProductList = createAsyncThunk(
    'product/getList',
    async (_, { dispatch }) => {
        const [res, err] = await handleRequest(productNewService.getProducts());
        if (!res || err || res.status !== 1) throw new Error(err);
        dispatch(setProductList(res.data as unknown as IProduct[]));
        return res.data;
    }
)

const getProductDetail = createAsyncThunk(
    'product/detail',
    async (slug?: string) => {
        const [res, err] = await handleRequest(productService.getProduct(slug));
        if (!res || err) throw new Error(err);
        return res.data;
    }
)
export const productSlice = createSlice({
    name: 'productStore',
    initialState,
    reducers: {
        setProductList(state, action: PayloadAction<IProduct[]>) {
            state.productStore = action.payload
        },
        setProductDetail(state, action: PayloadAction<IProduct>) {
            state.productDetail = action.payload;
        }
    }
})
export const productPrvSliceActions = { getProductList, getProductDetail };
export const { setProductList, setProductDetail } = productSlice.actions;
export default productSlice.reducer;